<template>
  <div>
    <slot name="title">
      <div class="text-body-2 text-secondary--text d-flex align-center mb-1">
        {{ t('Минимальная учёная степень', options) }}

        <v-btn
          icon
          text
          small
          color="text-info"
          class="ml-1"
          @click="openDialog"
        >
          <v-icon size="20">
            ui-icon-circle-info
          </v-icon>
        </v-btn>
        <v-overlay
          :value="isDialogOpened"
          @click="closeDialog"
        />
        <DialogBottomSheet
          :is-visible="isDialogOpened"
          :width="isMobile ? undefined : 375"
          hide-overlay
          attach=".vue-the-doctors-filters .v-application"
          content-class="rounded-0"
          @dialog-bottom-sheet:change-visible="closeDialog"
        >
          <v-card
            tile
            class="px-2 py-4"
          >
            <div class="pa-2 mb-2">
              <div class="text-h6 mb-2">
                {{ t(DESCRIPTION.academicDegree.title, options) }}
              </div>
              <div class="text-body-2 mb-4">
                {{ t(DESCRIPTION.academicDegree.description, options) }}
              </div>
              <div class="text-subtitle-2">
                {{ t(DESCRIPTION.candidateOfScience.title, options) }}
              </div>
              <div class="text-body-2 mb-4">
                {{ t(DESCRIPTION.candidateOfScience.description, options) }}
              </div>
              <div class="text-subtitle-2">
                {{ t(DESCRIPTION.doctorOfScience.title, options) }}
              </div>
              <div class="text-body-2 mb-4">
                {{ t(DESCRIPTION.doctorOfScience.description, options) }}
              </div>
              <div class="text-subtitle-2">
                {{ t(DESCRIPTION.professor.title, options) }}
              </div>
              <div class="text-body-2">
                {{ t(DESCRIPTION.professor.description, options) }}
              </div>
            </div>
            <v-btn
              color="primary"
              block
              depressed
              @click="closeDialog"
            >
              {{ t('Понятно', options) }}
            </v-btn>
          </v-card>
        </DialogBottomSheet>
      </div>
    </slot>
    <v-chip-group
      :value="doctorFiltersState.science"
      column
      active-class="primary"
      @change="handleChangeChip"
    >
      <v-chip
        v-for="(chip, i) in scienceChips"
        :key="i"
        :value="chip.value"
        :color="chip.value === doctorFiltersState.science ? 'primary' : 'bg-primary'"
        :text-color="chip.value === doctorFiltersState.science ? 'bg-gray-0' : 'primary'"
      >
        {{ t(chip.name, options) }}
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue'
import I18NextVue from 'i18next'
import DialogBottomSheet from 'www/vue_components/common/core/DialogBottomSheet.vue'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'
import type { Filters } from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore.types'

const emit = defineEmits(['input'])
const props = defineProps<{ value: Filters }>()
const { value: doctorFiltersState } = toRefs(props)

const filtersStore = useFiltersStore()
const { isDialogOpened, openDialog, closeDialog } = useDialogManager('ChipGroupScience')
const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const isMobile = window.MOBILE_VERSION
const DESCRIPTION = {
  academicDegree: {
    title: 'Учёная степень',
    description: 'Говорит о специалисте как о научном сотруднике, преподавателе и исследователе.',
  },
  candidateOfScience: {
    title: 'Кандидат наук',
    description: 'Высокая квалификация и профессиональный опыт. Защитил диссертацию, опубликовал несколько статей.',
  },
  doctorOfScience: {
    title: 'Доктор наук',
    description: 'Не менее 10 научных публикаций с результатами исследований, весомый авторитет. Работы имеют научную новизну. Совершил научное открытие в области медицины.',
  },
  professor: {
    title: 'Профессор',
    description: 'Доктор наук со стажем преподавательской и научной деятельности не менее 10 лет, эксперт в своей области.',
  },
}

const scienceChips: ({ name: string, value: Filters['science'] })[] = [
  { name: 'Кандидат наук', value: 1 },
  { name: 'Доктор наук', value: 2 },
  { name: 'Профессор', value: 3 },
]

const handleChangeChip = (science: Filters['science']) => {
  filtersStore.updateUnsavedFilters({ science })
  emit('input', {
    ...doctorFiltersState.value,
    science,
  })
}
</script>
